import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { timeObjectFromMinutes } from '../../../../utilities/time';

const PauseShift = ({ shift }) => {
    const { minutes } = shift;
    if (!minutes) {
        return null;
    }
    const time = timeObjectFromMinutes(minutes, false);
    const timeHours = parseInt(time.hours, 10);
    const timeMinutes = parseInt(time.minutes, 10);
    return (
        <div className="pause-shift-wrapper">
            <div className="timeline-hours">
                <span>
                    <i className="material-icons">restaurant</i> {timeHours > 0 && <span>{timeHours} H</span>}{' '}
                    {timeMinutes > 0 && <span>{timeMinutes} MINS</span>} <FormattedMessage {...messages.break} />{' '}
                </span>{' '}
            </div>
        </div>
    );
};

PauseShift.propTypes = {
    shift: PropTypes.object
};

export default PauseShift;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/addTime/pauseShift.jsx